<template>
  <p class="commandLineInput">{{ commandHead }} ./ergebnis</p>
  <div class="result">
  <div class="resultBarBorder">
    <div id="progressBar"></div>
  </div>
  <p>{{ roundTeamMatchPercentage() }}% Übereinstimmung</p>
  <p>{{ checkUserCompability() }}</p>

  <div class="invite" v-show="invite == true">
    <result-humanresourcemanagement></result-humanresourcemanagement>
  </div>
  </div>
</template>

<script setup>

import ResultHumanresourcemanagement from "./ResultHumanresourcemanagement.vue";
import { ref, defineProps, defineEmits, onMounted } from 'vue';

const emit = defineEmits([['set-invitation']])

const invite = ref(false);

const props = defineProps({
  commandHead: null,
  teamMatchPercentage: null,
  visible: Boolean,
  invitation: Boolean,
  answerBilance: null,
});

onMounted(() => {
    changeColor(props.answerBilance.toString() + "%");
})
function roundTeamMatchPercentage() {
  //teamMatchPercentageRounded = teamMatchPercentageVar.toFixed(3);
  let val = props.teamMatchPercentage;
  let roundedVal = val.toFixed(2);
  return roundedVal;
}

function changeColor(width) {
      document.getElementById("progressBar").style.width = width;
}

function checkUserCompability(){
    if (props.answerBilance > 70) {
        invite.value = true;
        emit('set-invitation', invite.value);
        return "Du passt sehr gut ins Team";
      } else if (props.answerBilance > 60) {
        return "Du passt gut ins Team";
      } else {
        return "Vielen Dank für die Teilnahme";
      }
}

</script>

<style scoped>
.commandLineInput{
  text-align: left;
}
.result{
  margin-top: 2%;
  margin-left: 2%;
}
.resultBarBorder {
  background-color: transparent;
  border: 2px solid grey;
  height: 1rem;
  width: 70%;
}
#progressBar {
  background-color: #0f0f;
  height: 100%;
  width: 0%;
}

p {
  color: #0f0f;
  text-align: left;
}
</style>